export var ErrorSource;
(function (ErrorSource) {
    ErrorSource["Database"] = "Database";
    ErrorSource["Fortnox"] = "Fortnox";
    ErrorSource["Server"] = "Server";
})(ErrorSource || (ErrorSource = {}));
